import { useState } from 'react';
import { getInitialDataEntities } from '../controllers/entities';
import { CommonEntity, Query, Result } from '../interfaces';
import { CommonsEntityAdapter } from '../adapter/entities-adapter';
import { Adapter } from '../shared/adapter';
import { useSelector } from 'react-redux';

const initialState: Result<CommonEntity> = {
    loading: false,
    values : []
};

export default function useSearch() {
    const [result, setResult] = useState<Result<CommonEntity>>(initialState);
    const userState = useSelector((state: any) => state.user.user);
    console.log("userState", userState)

    const searchEntities = async (collection: string, query: Query, page?: number, limit?: number) => {
        try {
            setResult((prevResult) => ({ ...prevResult, loading: true }));
            const response = await getInitialDataEntities(collection || 'all', query, page, limit, userState?.me);

            try {
                Adapter.from(response.items).to((value) => new CommonsEntityAdapter(value).adapt())
            } catch (error) {
                console.log("errr", error);
            }
            setResult({
                values:Adapter.from(response.items).to((value) => new CommonsEntityAdapter(value).adapt()) ,
                loading: false,
                pagination: {
                    limit,
                    page,
                    total: response.meta.total
                }
            });
        } catch (error) {
            setResult((prevResult) => ({ ...prevResult, loading: false }));
        }
    }

    return {
        result,
        searchEntities
    }
}
